import NavDrawerContainer from './nav_drawer_container';

const NavDrawer = NavDrawerContainer;
export default NavDrawer;
